import { Logger } from '../auth/Logger';
import { headerConstants } from '../auth/AuthConstants';
import { logConstants } from './Constants';
import { ResponseToNative } from '../auth/dsAuth/data/AuthTypes';

export default class Utils {
	private static instance: Utils;
	anchor: HTMLAnchorElement = document.createElement('a');
	static getInstance(): Utils {
		if (!Utils.instance) {
			Utils.instance = new Utils();
		}
		return Utils.instance;
	}
	getOrigin(url: string): string {
		this.anchor.href = url;
		return this.anchor.origin;
	}
	getHost(url: string): string {
		this.anchor.href = url;
		return this.anchor.host;
	}
	getPathname(url: string): string {
		this.anchor.href = url;
		return this.anchor.pathname;
	}
	isHTTPS(url: string): boolean {
		this.anchor.href = url;
		return this.anchor.protocol === 'https:';
	}
	getSearchParams(url: string): URLSearchParams {
		this.anchor.href = url;
		return new URLSearchParams(this.anchor.search);
	}

	removeQueryStringAndHashFromUrl(url: string): string {
		try {
			const urlResponse = new URL(url);
			return urlResponse.origin + urlResponse.pathname;
		} catch (e) {
			Logger.getInstance().write(
				logConstants.ERROR,
				`Exception in removeQueryStringAndHashFromUrl${e.message}\n${e.stack}`
			);
			return '';
		}
	}

	getResponseForLogs(response: ResponseToNative) {
		const headersToRemove = [
			headerConstants.SET_COOKIE_HEADER,
			headerConstants.AUTHORIZATION_HEADER,
			headerConstants.COOKIE_HEADER,
		];

		const dataToLog = JSON.parse(JSON.stringify(response)); //creating a copy of the response

		if (dataToLog.URLResponse && dataToLog.URLResponse.body) {
			delete dataToLog.URLResponse.body;
		}
		if (dataToLog.token) {
			delete dataToLog.token;
		}
		if (dataToLog.URLResponse && dataToLog.URLResponse.headers) {
			for (const key in dataToLog.URLResponse.headers) {
				for (const header in headersToRemove) {
					if (key.toLowerCase() === headersToRemove[header].toLowerCase()) {
						delete dataToLog.URLResponse.headers[key];
					}
				}
			}
		}
		return dataToLog;
	}

	getRequestForLogs(inputParam: string): string {
		try {
			const inputParamToLog = JSON.parse(inputParam);
			if (inputParamToLog.url) {
				inputParamToLog.url = this.removeQueryStringAndHashFromUrl(inputParamToLog.url);
			}
			if (inputParamToLog.referenceUri) {
				inputParamToLog.referenceUri = this.removeQueryStringAndHashFromUrl(
					inputParamToLog.referenceUri
				);
			}
			if (inputParamToLog.headers) {
				for (const key in inputParamToLog.headers) {
					if (key.toLowerCase() == headerConstants.COOKIE_HEADER.toLowerCase())
						delete inputParamToLog.headers[key];
				}
			}
			return JSON.stringify(inputParamToLog);
		} catch (e) {
			Logger.getInstance().write(
				logConstants.ERROR,
				`Exception in getRequestForLogs ${e.message}\n${e.stack}`
			);
			return '';
		}
	}

	/**
	 * Returns the canonicalized version of a given URL
	 * @param url Url which needs to be canonicalized
	 */
	getSafeUrl(url: string): string {
		try {
			return new URL(url).toString();
		} catch (e) {
			Logger.getInstance().write(
				logConstants.ERROR,
				'Invalid url sent to getSafeUrl : ' + url
			);
		}
		return url;
	}

	/**
	 * Checks if the function exists on the bridge object for ex: ctxsNative for aml
	 *
	 * @param {unknown} bridge
	 * @param {string} functionName
	 * @returns {boolean}
	 * @memberof Utils
	 */
	isBridgeFunctionSupported(bridge: unknown, functionName: string): boolean {
		// In windows typeof ctxsNative.<fnName> throws an error if the function doesn't exists
		try {
			return typeof bridge[functionName as keyof typeof bridge] === 'function'
				? true
				: false;
		} catch (e) {
			return false;
		}
	}
}
